var React = require('react');

function StovePot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M6.75,3.75h10.5a0,0,0,0,1,0,0v11a1,1,0,0,1-1,1H7.75a1,1,0,0,1-1-1v-11A0,0,0,0,1,6.75,3.75Z","key":1}),React.createElement("line",{"className":"a","x1":"5.25","y1":"3.75","x2":"18.75","y2":"3.75","key":2}),React.createElement("line",{"className":"a","x1":"6.75","y1":"6.75","x2":"3.75","y2":"6.75","key":3}),React.createElement("line",{"className":"a","x1":"20.25","y1":"6.75","x2":"17.25","y2":"6.75","key":4}),React.createElement("path",{"className":"a","d":"M9,3.75a3,3,0,0,1,6,0","key":5}),React.createElement("path",{"className":"a","d":"M18,23.25l-1.121-2.021a.835.835,0,0,0-.691-.413.865.865,0,0,0-.744.332l-.073.1a.865.865,0,0,1-.744.332.838.838,0,0,1-.692-.413l-1.11-2a1.024,1.024,0,0,0-1.65,0l-1.11,2a.838.838,0,0,1-.692.413.865.865,0,0,1-.744-.332l-.073-.1a.865.865,0,0,0-.744-.332.835.835,0,0,0-.691.413L6,23.25","key":6})]);
}

StovePot.defaultProps = {"id":"Regular","viewBox":"0 0 24 24"};

module.exports = StovePot;

StovePot.default = StovePot;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/stove-pot.svg
// module id = 1086
// module chunks = 0